
import Card from '../../../components/base/Card';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "Sarah Johnson",
      location: "Cape Town",
      rating: 5,
      text: "Chef Thabo created an absolutely magical evening for our anniversary. The traditional South African dishes with a modern twist were phenomenal. Every guest was raving about the food!",
      event: "Anniversary Dinner",
      image: "https://public.readdy.ai/ai/img_res/21b7421af312ec45078a5113b06281ba.jpg"
    },
    {
      name: "Michael Chen",
      location: "Johannesburg",
      rating: 5,
      text: "We hired Chef Sarah for our corporate event and she exceeded all expectations. The presentation was stunning and the flavors were incredible. Our international clients were thoroughly impressed.",
      event: "Corporate Event",
      image: "https://readdy.ai/api/search-image?query=Professional%20Asian%20businessman%20in%20his%2030s%20smiling%20confidently%2C%20business%20attire%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting&width=100&height=100&seq=testimonial2&orientation=squarish"
    },
    {
      name: "Nomsa Mthembu",
      location: "Durban",
      rating: 5,
      text: "Chef Mandla's seafood preparation was absolutely divine. He brought the ocean to our table with the freshest ingredients and incredible technique. A truly unforgettable experience!",
      event: "Family Celebration",
      image: "https://readdy.ai/api/search-image?query=Beautiful%20African%20woman%20in%20her%2030s%20with%20warm%20smile%2C%20elegant%20appearance%2C%20professional%20headshot%20style%2C%20clean%20background%2C%20natural%20lighting&width=100&height=100&seq=testimonial3&orientation=squarish"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Our <span className="text-emerald-600">Clients Say</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied clients have to say 
            about their exceptional private chef experiences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="p-8">
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400"></i>
                  </div>
                ))}
              </div>
              
              <blockquote className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </blockquote>
              
              <div className="flex items-center">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                  <p className="text-xs text-emerald-600 font-medium">{testimonial.event}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
